module.exports = __webpack_public_path__ + "img/orange_132.54d85aea.png";